<template>
    <div ref="domRef" v-html="htmlStr" class="word-to-img" :style="{backgroundColor: `${bgColor}`,width: `${wWidth}px`}"></div>
</template>
<script>
    import util from '@/util';
    import uploadService from '@/request/service/fileupload-service';
    export default{
        props:{
            wWidth: [Number, String],
            WHeight: [Number, String],
            htmlStr: String,
            bgColor: {type:String, default: '#fff'}
        },
        methods:{
            _getImg(){
                let self = this;
                return  new Promise((resolve, reject) => {
                    util.html2canvas(self.$refs.domRef, self.wWidth).then((canvas) => {
                        let base64 = canvas.toDataURL();
                        uploadService.uploadFileByBase64(base64).then(({url, properties}) => {
                            let height = +(properties.split('x')[1]);
                            resolve({url, height});
                        }).catch((error) => {
                            reject(error);
                        });
                    }).catch((error) => {
                        reject(error);
                    });
                });
            }
        }
    }
</script>
<style lang="scss">
    .word-to-img{
        display: inline-block;
        font-weight: 400;
        font-family: sans-serif;
        color: #000;
        .t-round{
            display: block !important;
        }
        table{
            width: 100% !important;
            table-layout: fixed;
            border-collapse: collapse;
        }
        p {
            margin: 0px;
        }
        table, td {
            border-color: #000;
            word-break: break-all;
            box-sizing: border-box;
        }
        td {
            text-align: left;
            border-right: 0px;
            border-bottom: 0px;
        }
    }
</style>